import React from 'react';
import { Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { OfferIntro } from '../../offerIntro';

export const IntroOfferRenderer = ({ data, ...props }) => {
  if (!data?.original || data?.original?.id === 'load-more' || !data?.original?.contact) {
    return '';
  }

  const { original, sharedList } = data;

  return (
    <Flex px="8px" alignItems="center" height="100%" width="100%">
      <OfferIntro
        contact={original.contact}
        company={original.company}
        sharedList={sharedList}
        onOfferIntoButtonClicked={() => {
          props.node.setRowHeight(100);
          props.api.onRowHeightChanged();
        }}
      />
    </Flex>
  );
};

IntroOfferRenderer.propTypes = {
  data: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
  api: PropTypes.object.isRequired,
};
